import { $api } from "../generated/client";


type UseGetReturnRequestAvailableCarriersQueryOptions = {
  shopId: string;
  returnRequestId: string;
};

export default function useGetReturnRequestAvailableCarriers({
                                                               shopId,
                                                               returnRequestId,
                                                             }: UseGetReturnRequestAvailableCarriersQueryOptions) {
  return $api.useQuery("get", "/shops/{shopId}/return-requests/{returnRequestId}/available-carriers", {
    params: { path: { shopId, returnRequestId } },
  });
}
